import {axios as http} from "@/plugins/http"

export default class Api {
    static item(couponId, sourceId) {
        return http.get(`/api/v1/promocodes/coupon/${couponId}/${sourceId}`)
    }

    static items(query) {
        let config = {
            params: query,
        }
        return http.get("/api/v1/promocodes/coupon", config)
    }

    static cancel(data) {
        return http.post("/api/v1/promocodes/coupon/cancel", data)
    }

    static async publish(data) {
        return http.post("/api/v1/promocodes/coupon/publish", data)
    }

    static delete(couponId, sourceId) {
        return http.delete(`/api/v1/promocodes/coupon/${couponId}/${sourceId}`)
    }

    static restore(couponId, sourceId) {
        return http.patch(`/api/v1/promocodes/coupon/${couponId}/${sourceId}`)
    }

    static couponTypes() {
        return http.get("/api/v1/promocodes/coupon/type")
    }

    static couponViews() {
        return http.get("/api/v1/promocodes/coupon/view")
    }
}
